<template>
    <ModalWithButton
        name="create-group"
        title="Crear nuevo grupo de precios"
        button_title="Crear nuevo grupo"
        @cerrar="cerrar"
    >
        <Form
            :data="grupo"
            @terminado="crear()"
        />
    </ModalWithButton>
</template>

<script>
    import ModalWithButton from '@/components/backend/components/ModalWithButton.vue'
    import Form from '@/components/backend/abonos/precios/grupos/Form.vue';

    export default {
        data() {
            return {
                grupo: {}
            }
        },
        methods: {
            crear() {
                if(! this.loading) {
                    this.loading = true;

                    this.grupo.filters = {};
                    this.grupo.lista_abonado_id = this.$store.getters.getListaId;
                    this.grupo.lista_id = this.$store.getters.getListaId;
                    this.grupo.teatro_id = this.$store.getters.getTeatroId;

                    this.$store.dispatch(this.config.getVuexAlias('back.precios.grupos.crear'), this.grupo).then(res => {
                        this.$modal.hide('create-group');
                        this.$emit('creado');
                        this.loading = false;
                        this.grupo = {};
                    });
                }            
            },
            cerrar() {
                this.grupo = {};
            }
        },
        components: {
            ModalWithButton, Form
        }
    }
</script>